module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Regular-WebS.b7c58e3f.woff2";